/**
 * The queue ticket, printed under the receipt — QA report §5.3.
 *
 * A tear-off strip: the clinic, the turn number as the largest thing on the
 * paper, how many were ahead when it was issued, and the QR that opens the
 * patient's live page (the turn, and their record). Drawn in ink on paper
 * whatever the screen's theme, like the receipt it is printed with.
 *
 * The QR is the server's SVG (Backend/lib/shareLink qrSvgFor): generated from
 * our own URL by the qrcode library, never from user input, so it is inlined.
 */

import { formatDmy, ltr } from '../../domain/bidi';

export function QueueTicketSlip({ ticket, hospitalName = null }) {
  if (!ticket) return null;
  return (
    <div className="queue-slip" data-ticket-number={ticket.number}>
      <p className="queue-slip__cut">✂ ـ ـ ـ ـ ـ تذكرة الدور ـ ـ ـ ـ ـ</p>
      <div className="queue-slip__body">
        <div className="min-w-0 flex-1">
          {hospitalName && <p className="queue-slip__hospital">{hospitalName}</p>}
          <p className="queue-slip__clinic">{ticket.clinic?.name || 'العيادة'}</p>
          {ticket.doctorName && <p className="queue-slip__doctor">{ticket.doctorName}</p>}
          <p className="queue-slip__label">رقم الدور</p>
          <p className="queue-slip__number" dir="ltr">
            {ticket.number}
          </p>
          <p className="queue-slip__ahead">
            {ticket.state === 'serving' ? 'دورك الآن' : <>أمامك عند الإصدار: <b dir="ltr">{ticket.ahead ?? 0}</b></>}
          </p>
          <p className="queue-slip__meta">
            {ticket.day ? ltr(formatDmy(ticket.day)) : ''} · امسح الرمز لمتابعة دورك وملفك مباشرة
          </p>
        </div>
        {ticket.qrSvg && (
          <div className="queue-slip__qr" aria-label="رمز متابعة الدور" dangerouslySetInnerHTML={{ __html: ticket.qrSvg }} />
        )}
      </div>
    </div>
  );
}

export default QueueTicketSlip;
